import React, { useEffect, useRef, useState } from 'react';
import * as UTIF from 'utif';

const TIFFViewer = ({
  fileUrl,
  setPages,
  scale,
  pages,
  currentPage,
  rotation,
  setScale,
  setRotation,
  setCurrentPage,
}) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [scrollStart, setScrollStart] = useState({ left: 0, top: 0 });

  // Load TIFF
  useEffect(() => {
    const loadTIFF = async () => {
      const res = await fetch(fileUrl);
      const buf = await res.arrayBuffer();
      const ifds = UTIF.decode(buf);
      const renderedPages = ifds.map((ifd) => {
        UTIF.decodeImage(buf, ifd);
        const rgba = UTIF.toRGBA8(ifd);

        const canvas = document.createElement('canvas');
        canvas.width = ifd.width;
        canvas.height = ifd.height;

        const ctx = canvas.getContext('2d');
        const imageData = ctx.createImageData(canvas.width, canvas.height);
        imageData.data.set(rgba);
        ctx.putImageData(imageData, 0, 0);

        return canvas;
      });

      setPages(renderedPages);
      setCurrentPage(0);
    };

    loadTIFF();
  }, [fileUrl]);

  const drawToCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const image = pages[currentPage];
    if (!canvas || !ctx || !image) return;

    const imgW = image.width;
    const imgH = image.height;

    const scaledW = imgW * scale;
    const scaledH = imgH * scale;

    const rotateVertical = rotation % 180 !== 0;
    const canvasWidth = rotateVertical ? scaledH : scaledW;
    const canvasHeight = rotateVertical ? scaledW : scaledH;

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    ctx.translate(canvasWidth / 2, canvasHeight / 2);
    ctx.rotate((rotation * Math.PI) / 180);
    ctx.scale(scale, scale);
    ctx.drawImage(image, -imgW / 2, -imgH / 2);
    ctx.restore();
  };

  useEffect(() => {
    if (pages.length > 0) {
      drawToCanvas();
    }
  }, [rotation, scale, currentPage, pages]);

  // Mouse drag scroll
  const onMouseDown = (e) => {
    e.preventDefault(); // 🔥 required to prevent unwanted selection
    setIsDragging(true);
    setDragStart({ x: e.clientX, y: e.clientY });
    setScrollStart({
      left: containerRef.current.scrollLeft,
      top: containerRef.current.scrollTop,
    });
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    const dx = e.clientX - dragStart.x;
    const dy = e.clientY - dragStart.y;
    containerRef.current.scrollLeft = scrollStart.left - dx;
    containerRef.current.scrollTop = scrollStart.top - dy;
  };

  const onMouseUp = () => setIsDragging(false);

  return (
  <div
  ref={containerRef}
  style={{
  
    height: '100%',
    overflow: 'auto',
    display:'flex',
    justifyContent:'center',

    border: '1px solid #ccc',
    cursor: isDragging ? 'grabbing' : 'grab',
    background: '#f5f5f5',
    position: 'relative',
  }}
  onMouseDown={onMouseDown}
  onMouseMove={onMouseMove}
  onMouseUp={onMouseUp}
  onMouseLeave={onMouseUp}
>
    <div>
  <canvas
    ref={canvasRef}
    style={{
      display: 'block',
    }}
  />
    </div>

</div>
  );
};

export default TIFFViewer;
